import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#154D93',
        // fill: 'url(#SVGID_1_)',
    },

    st1: {
        fill: '#51B5E5',
    },

    st2: {
        fill: '#022958',
    },

    st3: {
        fill: '#FFFFFF',
    },

    st4: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st5: {
        fontSize: '15px',
        // fontWeight: '600',
    },

    st6: {
        clipPath: 'url(#SVGID_2_)',
    },

}));
